import { render, staticRenderFns } from "./remove-order-from-invoice-modal.vue?vue&type=template&id=52adb052&lang=pug"
import script from "./remove-order-from-invoice-modal.vue?vue&type=script&lang=js"
export * from "./remove-order-from-invoice-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports